export default __webpack_public_path__ + "static/Emilie-photo-de-profil-f2759172538b910ee99e4d5bd697f683.jpg";